<template>
  <div class="common-card auction">
    <div class="spaceLeft" style="align-items: baseline;">
      <div class="detail-title-1">My auction</div>
      <div style="color: #DCE0E7;font-size: 0.18rem;margin-top: 0.2rem;">Won/Participated: {{ info.auctionWinCount || 0 }}/{{ info.auctionsCount || 0 }}</div>
      <!-- <el-button type="text" @click="toDetail">
        Details
        <i class="el-icon-arrow-right" /></el-button> -->
    </div>
    <el-row :gutter="28">
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="common-card">
          <div class="common-card-main">
            <div class="flexStart">

              <div style="flex:1">
                <div class="spaceBetween" style="min-height:0.44rem;margin-bottom: 0.44rem;">
                  <div class="spaceLeft card-text-1">
                    <div class="logo">
                      <img src="@/assets/image/exchange/TCashIcon.png">
                    </div>
                    TCash Spent
                  </div>
                  <el-button type="primary"
                    style="border: 0px;background: linear-gradient( 90deg, #0E3491 0%, #225BFC 100%);"
                    v-if="+info.auctionAmount > 0" @click="$router.push('/TCashFinance/auction/placeBid/record')"><i
                      class="iconfont trn-up" /> Withdraw TCash</el-button>
                </div>
                <!-- <div class="card-text-3" style="margin-bottom:0.24rem;">
                  Cumulative bids {{ info.auctionsCount || 0 }}
                </div> -->
                <div class="card-text-2">
                  <span><big-number :number.sync="info.auctionAmount" /></span>
                  <span class="unit">TCash</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <div class="common-card">
          <div class="common-card-main">
            <div class="flexStart">

              <div style="flex:1">
                <div class="spaceBetween" style="min-height:0.44rem;margin-bottom: 0.44rem;">
                  <div class="spaceLeft card-text-1">
                    <div class="logo">
                      <img src="@/assets/image/exchange/unit.png">
                    </div>
                    UNIT Won
                  </div>
                  <el-button type="primary"
                    style="border: 0px;background: linear-gradient( 90deg, #0E3491 0%, #225BFC 100%);"
                    v-if="+info.auctionWinAmount > 0" @click="$router.push('/TCashFinance/auction/placeBid/record')"><i
                      class="iconfont trn-up" /> Withdraw winnings</el-button>
                </div>
                <!-- <div class="card-text-3" style="margin-bottom:0.24rem;">
                  Auction success {{ info.auctionWinCount || 0 }} times
                </div> -->
                <div class="card-text-2">
                  <big-number :number.sync="info.auctionWinAmount" />
                  <span class="unit">UNIT</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- <div class="detail-title-2">In auction</div>
    color: #fff;
    <el-table class="common-table" :data="tableList" v-loading="loading">
      <el-table-column prop="number" label="Bid Number" align="left" />
      <el-table-column prop="highValue" label="Current Bid" align="left">
        <template slot-scope="{ row }">
          <big-number :number="row.highValue" /><span class="td-word-sm">TCash</span>
        </template>
      </el-table-column>
      <el-table-column prop="myBid" label="My Bid" align="right">
        <template slot-scope="{ row }">
          <big-number :number="row.auctiondetail[0] && row.auctiondetail[0].amount" />
          <span class="td-word-sm">TCash</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :total.sync="queryParams.total" :page.sync="queryParams.page" :limit.sync="queryParams.pageSize"
      @pagination="getList()" /> -->
  </div>
</template>

<script>
import { myHistorylist } from "@/api/auction.js";
import { mytotal } from "@/api/ustn/profile.js";
export default {
  components: {},
  data() {
    return {
      loading: false,
      tableList: [],
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      currentcumulativebid: 0,
      info: {}
    };
  },
  computed: {},
  methods: {
    async init() {
      this.contractBid = this.$store.getters.contractMap["contractBid"].contract;
      this.contractBidAddress = this.$store.getters.contractMap["contractBid"].address;
      if (!this.$store.getters.metaMaskObj.account) {
        return;
      }
      this.getInfo();
      this.getList();
    },
    getInfo() {
      mytotal({
        account: this.$store.getters.metaMaskObj.account
      }).then(res => {
        console.log('mytotal', res);
        this.info = res.data || {};
      });
    },
    getList() {
      this.loading = true;
      myHistorylist({
        pageSize: this.queryParams.pageSize,
        page: this.queryParams.page,
        status: 2,
        overTimeFrom: new Date().getTime(),
        overTimeTo: new Date().getTime() + 1000 * 60 * 60 * 24,
        account: this.$store.getters.metaMaskObj.account
      })
        .then(res => {
          this.tableList = res.data ? res.data.data : [];
          this.queryParams.total = res.data.total || 0;
          this.loading = false;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    async getCurrentcumulativebid() {
      try {
        let res = await this.contractBid.methods["getBidData"](
          this.account
        ).call({
          from: this.account
        });
        this.currentcumulativebid = res.amount || 0;
      } catch (e) {
        console.log(e);
      }
    },
    toDetail() {
      this.$router.push("/TCashFinance/auction/placeBid/record");
    }
  },
  created() {
    this.init();
  }
};
</script>
<style scoped lang="scss">
.auction {
  margin: 0.32rem auto;
  border: 1px solid #272D38;
  border-radius: 0.24rem;
  background: #FAFAFA;
  padding: 0.56rem;
  background: linear-gradient(90deg, #020202 0%, #020202 42%, #00266B 100%);

  .common-card {
    margin-top: 0.24rem;
    padding: 0.28rem 0.24rem;
    background: #001A49;
    position: relative;
    border-radius: 0.2rem;
    border: 1px solid rgba(255, 255, 255, .19);

    .common-card-main {
      .logo {
        width: 0.4rem;
        height: 0.44rem;
        // padding: 0.06rem;
        border-radius: 50%;
        // margin: 0.12rem 0.14rem 0 0;
        margin-right: 0.1rem;
        img {
          width: 100%;
        }
      }
    }
  }

  >>>.el-button--text {
    color: #225BFC !important;
  }

  ::v-deep  .el-button--medium {
    padding: 0.09rem 0.16rem;
    font-size: 0.16rem;
    border-radius: 0.04rem;

    &.el-button--primary {
      background: #3172FD;
      border-color: #3172fd;
    }

  }

  .detail-title-1 {
    color: #fff;
    margin-right: 0.2rem;
  }

  .card-text-1 {
    font-size: 0.32rem;
    color: #DCE0E7;
    font-weight: 600;
    font-family: Roboto-Medium, Roboto;
  }

  .card-text-3 {
    font-size: 0.16rem;
    color: #929DAD;
  }

  .card-text-2 {
    font-size: 0.32rem;
    color: #1f1f1f;
    font-weight: 500;
    font-family: Roboto-Medium, Roboto;
    padding-left: 0.5rem;
    .big-number {
      color: #fff;
      font-size: 0.36rem;
    }
  }

  .unit {
    font-size: 0.2rem;
    color: #929DAD;
    font-weight: 500;
    font-family: Roboto-Regular, Roboto;
  }

  .detail-title-2 {
    color: #fff;
    font-size: 0.26rem;
    margin-top: 0.48rem;
    margin-bottom: 0.26rem;
  }

  ::v-deep  .common-table.el-table .el-table__header-wrapper th,
  ::v-deep  .common-table.el-table td {
    background: #efefef;
    height: 0.4rem;
    font-size: 0.16rem;
    font-weight: normal;
  }

  .td-type-img {
    width: 0.52rem;
    margin-right: 0.16rem;
  }
}

// .common-table {
//   background: #efefef;
// }</style>
